import { Actions } from 'ahooks/lib/useBoolean';
import { message } from 'antd';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile } from 'antd/es/upload/interface';

export const getBase64 = (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

export const handleImgChange = (
  set: Actions['set'],
  onChange?: (value: string) => void,
) => (
  info: UploadChangeParam<UploadFile>,
) => {
  if (info.file.status === 'uploading') {
    set(true);
  }

  if (info.file.status === 'error') {
    set(false);
    message.error('Image not uploaded, try again later');
  }

  if (info.file.status === 'done') {
    getBase64(info.file.originFileObj as RcFile, () => {
      set(false);
      onChange?.(info.file.response.id);
    });
  }
};

export const beforeUpload = (file: RcFile) => {
  const isLt2M = file.size / 1024 / 1024 < 10;
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }

  if (!isLt2M) {
    message.error('Image must smaller than 10MB!');
  }

  return isJpgOrPng && isLt2M;
};
